import { render, staticRenderFns } from "./publicWelfareDetail.vue?vue&type=template&id=765afabb&scoped=true&"
import script from "./publicWelfareDetail.vue?vue&type=script&lang=js&"
export * from "./publicWelfareDetail.vue?vue&type=script&lang=js&"
import style0 from "./publicWelfareDetail.vue?vue&type=style&index=0&id=765afabb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765afabb",
  null
  
)

export default component.exports